import gsap, { Power2 } from 'gsap';
import BGMedia from '../3D/BGMedia';
import CarruselSlider from '../3D/CarruselSlider';
import Scene from '../3D/Scene';
import { Basics, isSmartphone, isTouch } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { DataHolder } from '../DataHolder';
import Header from '../layout/Header';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Default from './Default';
import Main from '../main';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import WheelControls from '../_app/cuchillo/scroll/WheelControls';
import DefaultNoScroll from './DefaultNoScroll';

export default class Archive extends DefaultNoScroll {
  
  _links;
  _linkActive = null;
  _timer;
  _totalLinks = 0;
  _overlap = {
    start: 0,
    actual: null
  };
  
  constructor() {
    super();

    Basics.oldPage = "archive";
    document.body.classList.add("--remove-footer");
    DataHolder.update();

    this.setupLinks();
    this.wall = new Archive__Wall(GetBy.class("__ulDeco", this.container)[0]);
    this.wallLinks = new Archive__List_Links(GetBy.class("__ul", this.container)[0]);
    this.wallImages = new BGMedia(GetBy.id("archive-slider"));
    this.mainLink = GetBy.class("__mainlink", this.container)[0];
    
    Scene.add(this.wallImages);
    
    this.actual = 0;
    this.position = 0;
    this.total = isTouch? Metrics.WIDTH * (this._totalLinks * .5) : Metrics.HEIGHT * (this._totalLinks * .5);
    this.setupWheel();
  }

  setupWheel() {
    
    const check = () => {
      if(this.position > this.total) {
        this.position = this.total - this.position;
      } else if(this.position < 0) {
        this.position = this.total + this.position;
      }
      const progress = this.position/this.total;
      const actual = Math.round((this._totalLinks-1) * progress);
            
      if(this.actual != actual) {
        this.actual = actual;
        this._links[this.actual].over(null, true);
      }
    }

    this._wheel = new WheelControls({
      onForward:(__delta)=>{
        this.position = this.position - __delta;
        check();
      },
      onBackward:(__delta)=>{
        this.position = this.position - __delta;
        check();
      },
      timeToActive:0
    });
    this._wheel.enabled = true;
  }

  beforeShow() {
    Header.title.hide();
    Header.mode = "INVERT";
    super.beforeShow();
  }

  afterShow() {
    //WebGLSketch.enableDOF(true);
    //WebGLSketch.enableFilmGrain(true);
    
    super.afterShow();
    
  }

  setupLinks() {
    this._links = [];
    const temp = GetBy.selector("a", this.container);
    this._tlLinks = gsap.timeline({ paused: true });

    temp.forEach(dom => {
      if(!dom.classList.contains("__mainlink")) {
        if(this._overlap.actual == null) this.checkHeaderOverlap(dom, this._links.length);

        this._links.push(new Archive__Link(dom, this._links.length, this.showProject.bind(this), this.outProject.bind(this)));
        gsap.set(dom,{opacity:0});
        this._tlLinks.to(dom, { opacity: 1, ease: Power2.easeIn, duration: 0.01}, 0 + (this._links.length - 1) * 0.02);
      }
    });

    this._totalLinks = this._links.length;
  }

  checkHeaderOverlap(dom, index) {
    if(!isSmartphone) return;

    const rect = dom.getBoundingClientRect();
    if (rect.y > Metrics.CENTER_Y - rect.height * 3) {
      dom.classList.add('--margin');
      this._overlap.start = index;
      this._overlap.actual = index;
    }
  }

  gotoOverlap(index) {
    if(!isSmartphone) return;
    
    const newIndex = this._overlap.start + index;
  
    if(this._overlap.actual != null && this._overlap.actual < this._links.length) {  this._links[this._overlap.actual].link.classList.remove('--margin');  }    
    this._overlap.actual = newIndex;
    if(this._overlap.actual < this._links.length) {  this._links[this._overlap.actual].link.classList.add('--margin');  }
  }

  show__effect() {
    if (this.isFirstTime) {
      Wrap.show(() => {
        Header.show(0);
        this.afterShow();
        if(isTouch) setTimeout(()=> {this.showProject(0)},1000);
        this._tlLinks.restart();
      },{duration:.1});
    } else {
      Wrap.show(() => {
        this._tlLinks.restart();
        if(isTouch) setTimeout(()=> {this.showProject(0)},1000);
      },{duration:.01});
      this.afterShow()
    }    
  }


  hide__effect() {
      clearTimeout(this._timer);
      
      this.wallImages.hide();
      this.wall.hide(.1);
      

      Wrap.hide(() => { this.afterHide() }, {delay:.1, duration:.2});
  }

  beforeHide() {
    document.body.classList.remove("--remove-footer");
    super.beforeHide();
  }

  afterHide() {
    super.afterHide();
    WebGLSketch.enableDOF(false);
    WebGLSketch.enableFilmGrain(false);
  }

  resize() {
    super.resize();
    this.wall.resize();
  }

  loop() {
    this.wall.loop();
  }

  showProject(index, __hasMoveLinks = true) {
    clearTimeout(this._timer);

    if(this._linkActive) this.hideLink();
    this._linkActive = this._links[index];

    const title = this._linkActive.title;
    const url = this._linkActive.url;

    this.mainLink.setAttribute("href", url);
    this._links[index].setActive(true);
    this.wallImages.show(index);
    this.wall.goto(index);

    if(__hasMoveLinks) {
      this.wallLinks.goto(index);
      if(this.wallLinks.offset > 0) this.gotoOverlap(index);
    }
    
    if(!isTouch) {
      Header.changeTitle(title, url);
      this.hideProject(true);
    }
  }

  hideLink() {
    this._linkActive.setActive(false);
    this._linkActive = null;
  }

  outProject() {
    this.hideProject();   
  }

  hideProject(__isAutomatic = false) {
    if(this._linkActive?.isOver) return;
    if(this._linkActive && !__isAutomatic) this.hideLink();

    clearTimeout(this._timer);
    this._timer = setTimeout(()=> { 
      this.wallImages.hide();
      this.wall.hide();
      this.hideLink();
      this.mainLink.setAttribute("href", "#");
      Header.hideTitle();
    }, 3000);
  }

  _dispose() {
    super._dispose();

    Scene.remove(this.wallImages);
    this.wallImages.dispose();
    this.wall.dispose();
    this.wallLinks.dispose();
    this._wheel.dispose();

    if(!isTouch) {
      this._links.forEach(link => {
        link.dispose();
      });
    }
  }
}

class Archive__Link {
  constructor(dom, index, callHover, callOut) {
    this.link = dom;
    this.index = index;
    this.title = dom.dataset.title;
    this.url = dom.getAttribute("href");
    this.isOver = false;
    
    this._callbacks = {
      over: callHover,
      out: callOut
    }
    this._calls = {
      over: this.over.bind(this),
      out: this.out.bind(this)
    }

    this.link.addEventListener(Basics.mouseOver, this._calls.over);
    if(this._callbacks.out) this.link.addEventListener(Basics.mouseOut, this._calls.out);
  }

  setActive(__isActive) {
      if(__isActive) this.link.classList.add("--active");
      else this.link.classList.remove("--active");
  }

  over(e, isAuto = false) {
    this.isOver = true;
    this._callbacks.over(this.index, isAuto);
  }

  out(e) {
    this.isOver = false;
    this._callbacks.out();
  }

  dispose() {
    this.link.removeEventListener(Basics.mouseOver, this._calls.over);
    if(this._callbacks.out) this.link.removeEventListener(Basics.mouseOut, this._calls.over);
  }
}

class Archive__Wall {
  _y = 0;
  
  set y(__y) {
    this._y = __y;
    this.container.style[CSS.transform] = CSS.translate3D(0,this._y,0);
  }
  get y() { return this._y; }
  
  constructor(dom) {
    this.container = dom;
    this.isShow = false;
    this.height = 0;
    this.offset = 0;
    this.yTo = 0;
    this.items = [...GetBy.selector("li", this.container)];
    this.total = this.items.length;
    this.resize();
  }

  show() {
    if(this.isShow) return;
    this.isShow = true;
    gsap.killTweensOf(this.container);
    gsap.to(this.container,{alpha:1, ease:Power2.easeOut, duration:.4, delay:.1});
  }

  hide(__delay = .2) {
    if(!this.isShow) return;
    this.isShow = false;
    gsap.killTweensOf(this.container);
    gsap.to(this.container,{alpha:0, ease:Power2.easeOut, duration:__delay, delay:0});
  }

  goto(__n) {
    this.show();
    this.yTo = this.offset * __n;
  }

  loop() {
    this._y = this._y + (this.yTo - this._y) * .1;
    if(Main.tick % 4 == 0) {
      this.y = this._y;
    }
  }

  resize() {
    this.height = this.container.getBoundingClientRect().height;
    this.offset = -(this.height - Metrics.HEIGHT)/this.total;
  }

  dispose() {
    this.container = null;
    this.height = null;
    this.offset = null;
    this._y = null;
    this.yTo = null;
    this.items = null;
    this.total = null;
  }
}

class Archive__List_Links {
  _y = 0;
  
  set y(__y) {
    this._y = __y;
    this.container.style[CSS.transform] = CSS.translate3D(0,this._y,0);
    this.title.style[CSS.transform] = CSS.translate3D(0,this._y,0);
  }
  get y() { return this._y; }
  
  constructor(dom) {
    this.title = GetBy.selector("h1.title-default")[0];
    this.container = dom;
    this.height = 0;
    this.offset = 0;
    this.items = [...GetBy.selector("li", this.container)];
    this.total = this.items.length;
    this.resize();
  }

  goto(__n) {
    this.y = this.offset * __n;
  }

  resize() {
    this.height = this.container.getBoundingClientRect().height;
    this.offset = Metrics.HEIGHT > this.height? 0 : -this.items[0].getBoundingClientRect().height;
  }

  dispose() {
    this.container = null;
    this.height = null;
    this.offset = null;
    this._y = null;
    this.yTo = null;
    this.items = null;
    this.total = null;
  }
}

ControllerPage._addPage("archive", Archive)

